import { render } from "./PriceList.vue?vue&type=template&id=f8e9bfc2&ts=true"
import script from "./PriceList.vue?vue&type=script&lang=ts"
export * from "./PriceList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__